Namespace 'Customer.Dashboard'

class Customer.Dashboard.SummaryView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/summary']

  events:
    'click .stale-refresh': 'onClickStaleRefresh'

  initialize: (@options = {}) ->
    @selectedFilter = @options.selectedFilter || throw new Error('Cannot instantiate a SummaryView without a selectedFilter')
    @filters =  @options.filters
    @filterEventHandler = @options.filterEventHandler
    @headerView = new Customer.Dashboard.SummaryHeaderView
      filter: @selectedFilter
      usersGroups: @options.usersGroups
      users: @options.users
      conversation_attributes: @options.conversation_attributes
      taxonomy_attributes: @options.taxonomy_attributes
    @staleNoticeView = new Customer.StaleNoticeView()
    @loadingNoticeView = new Customer.LoadingNoticeView()
    @bodyView = new Customer.Dashboard.SummaryBodyView
      tags: @options.tags
    @listenTo @headerView, 'search:settings:changed', @newSearchWithSettings
    @listenTo @headerView, 'search:settings:cancelled', @cancelSearch
    @listenTo @headerView.selectionView, 'summary:select:all', @toggleSelectAll
    @listenTo @headerView, 'summary:select:all', @selectAll
    @listenTo @headerView, 'summary:select:not:loaded', @selectNotLoaded
    @listenTo @headerView, 'summary:unselect:not:loaded', @unselectNotLoaded
    @listenTo @bodyView, 'tickets:loaded', @onTicketsLoaded
    @listenTo(@bodyView, 'counters:find:spin', @spinLoading)
    @listenTo(@bodyView, 'counters:find:stop', @spinStop)
    @listenTo @bodyView, 'dashboard:summary:previous-results', @loadMoreResults
    @listenTo @bodyView.ticketSummaries, 'ticket:summary:selected', @onSelectMultipleTickets
    @listenTo(@staleNoticeView,'refresh:tab', @onClickStaleRefresh)
    @listenTo(Backbone, 'update:counter', @filterUpdated)

    # tab events
    @listenTo @, 'focus:in', =>
      @focused = true
      $('.filter-dt').removeClass('selected')
      $('.filter-dt[data-id="' + @selectedFilter.id + '"]').addClass('selected')

    @listenTo @, 'focus:out', =>
      @focused = false
      clearInterval(@refreshTick)
      @selectedFilter.set('lastRefesh', null)
      $('.filter-dt[data-id="' + @selectedFilter.id + '"]').removeClass('selected')

  filterUpdated: (filter) ->
    return unless @selectedFilter
    return if filter.get('id') != @selectedFilter.get('id')
    return unless @focused
    @selectedFilter = filter
    @detectPendingRefresh()

  render: ->
    @$el.html(@template)
    @$el.find('#summary-header').append(@headerView.render().$el)
    @$el.find('#summary-body').append(@bodyView.render().$el)
    @$el.find('.stale-notice-container').html(@staleNoticeView.render().$el)
    @$el.find('.loading-notice-container').html(@loadingNoticeView.render().$el)
    @selectedFilter?.set('lastRefesh', Date.now())
    @detectPendingRefresh()
    @

  detectPendingRefresh: ->
    if @selectedFilter && (@selectedFilter.hasUnseenContent() || @hasToRefresh())
      if @automaticRefreshActive() && @ticketSelectionIsEmpty()
        @loadingNoticeView.showLoading()
        @onClickStaleRefresh()
      else if !@loadingNoticeView.loading
        @staleNoticeView.showRefreshNeeded()
        Backbone.trigger('show:stale-notice')

  onClickStaleRefresh: ->
    return false unless @focused
    @selectedFilter.set('lastRefesh', Date.now())
    @staleNoticeView.hideRefreshNeeded()
    @loadingNoticeView.showLoading()
    @newSearch()

  onTicketsLoaded: (total, tickets, reset) ->
    @headerView.bodyTicketsLoaded()
    @updateTicketSelectState()
    @searchCount = 0 if reset
    @loadingNoticeView.hideLoading()
    @adjustHeight()
    @enableSelectAll()

  cancelSearch: =>
    @bodyView.unsetSearchingState()

  newSearch: =>
    @bodyView.setSearchingState()
    @selectedFilter.markAsRead()
    @bodyView.search(@selectedFilter)
    @selectedFilter.setNewContent(false)

  newSearchWithSettings: (mustUpdateFilterCounters = true) ->
    @newSearch()
    @trigger('searchQueryChanged', mustUpdateFilterCounters)

  spinLoading:=>
    @trigger('counters:find:spin')

  spinStop:=>
    @trigger('counters:find:stop')

  loadMoreResults: =>
    @_keepCustomerSessionAlive()
    @searchCount += 1
    @bodyView.loadMore({filter: @selectedFilter, page_number: @searchCount})

  toggleFilters: =>
    @trigger('customer:summary:filters-column-was-toggled')

  ticketSelectionIsEmpty: ->
    return true unless @selectedAsCollection
    @selectedAsCollection.length == 0

  adjustHeight: =>
    mainHeaderHeight = $('#main-header').outerHeight(true)
    tabsHeight = $('#tabs-wrapper').outerHeight(true)
    summaryHeaderHeight = @$el.find('#summary-header').outerHeight(true)

    @bodyView.$el.css('height',
      "calc(100vh - #{
        mainHeaderHeight + tabsHeight + summaryHeaderHeight
      }px)"
    )

  toggleSelectAll: (checked) ->
    @bodyView.toggleSelectAll(checked)
    if checked
      @headerView.showMassiveActions(@bodyView.ticketSummaries, @includeNotLoaded())
      @validateAllSelected()
    else
      @headerView.removeMassiveActions()

  validateAllSelected: ->
    selectedCount = @bodyView.selectedSummaries().length
    loadedCount = @bodyView.loadedSummaries().length
    totalCount = @selectedFilter.getCounter()
    if selectedCount == totalCount
      @headerView.updateMassiveCountWithNotLoaded()
    else
      @headerView.updateMassiveCountWithLoaded(loadedCount, selectedCount)

  selectAll: (checked) ->
    @bodyView.toggleSelectAll(checked)
    @updateTicketSelectState(@includeNotLoaded())

  selectNotLoaded: ->
    @setIncludeNotLoaded(true)
    @bodyView.toggleSelectAll(@includeNotLoaded())
    @headerView.updateMassiveCountWithNotLoaded()

  unselectNotLoaded: ->
    @setIncludeNotLoaded(false)
    @headerView.updateMassiveCountWithLoaded()

  updateTicketSelectState: ->
    if @includeNotLoaded()
      @headerView.updateMassiveCountWithNotLoaded()
    else
      selectedCount = @bodyView.selectedSummaries().length
      loadedCount = @bodyView.loadedSummaries().length
      @headerView.updateSelectionView(loadedCount, selectedCount)
      totalCount = @selectedFilter.getCounter()
      if selectedCount == totalCount
        @headerView.updateMassiveCountWithNotLoaded()
      else
        @headerView.updateMassiveCountWithLoaded(loadedCount, selectedCount)


  updateMassiveActionsView: ->
    if @bodyView.ticketSummaries.selected().length == 0
      @headerView.removeMassiveActions()
    else
      @headerView.showMassiveActions(@bodyView.ticketSummaries, @headerView.isSelectAllChecked())
    @validateAllSelected()

  onSelectMultipleTickets: (checked) ->
    @setIncludeNotLoaded(false) unless checked
    @updateTicketSelectState()
    @updateMassiveActionsView()

  includeNotLoaded: ->
    @bodyView.includeNotLoaded

  setIncludeNotLoaded: (state) ->
    @bodyView.setIncludeNotLoaded(state)

  onSelectTab: (dashboard) ->
    dashboard.selectedFilter = @selectedFilter
    dashboard.history.clearState()
    dashboard.history.setFilter(@selectedFilter.id).go()
    @filterEventHandler.forcedUpdateCounters(@selectedFilter.id)
    dashboard.filterListView.renderFilters()
    dashboard.showFilters(true)
    @detectPendingRefresh()
    @setResfreshView()
    @bodyView.displayContent()

  onRefreshTab: (dashboard) ->
    return unless @ticketSelectionIsEmpty()
    dashboard.countersFindSpin()
    @headerView.selectionView.unselectAll()
    @newSearchWithSettings()

  setResfreshView: =>
    @refreshTick = setInterval () =>
      try
        @detectPendingRefresh()
      catch e
        jsLogger.warn(e)
    , (window.Customer.summariesForceRefresh.default || 30) * 1000

  onCloseTab: ->
    $('.filter-dt[data-id="' + @selectedFilter.id + '"]').removeClass('selected')
    @selectedFilter.get('query').search_text = ''
    @selectedFilter.setCallSummaryFirstTime(true)

  tabName: ->
    name = @selectedFilter.get('name')
    counter = @selectedFilter.counter
    if counter
      "#{name} (#{counter})"
    else
      name

  hasToRefresh: ->
    try
      lastRefesh = @selectedFilter.get('lastRefesh')
      return true unless lastRefesh
      seconds_ago = (window.Customer.summariesForceRefresh.default || 30)
      moment().subtract(seconds_ago - 1, 'seconds').unix() > moment(lastRefesh).unix()
    catch
      false

  automaticRefreshActive: ->
    @headerView.automaticRefreshActive()

  tabId: ->
    "filter-with-id-#{@selectedFilter.id}"

  uniqueId: ->
    "filter-with-id-#{@selectedFilter.id}"

  iconSelector: ->
    ""

  currentScrollPosition: () ->
    @bodyView.$el.scrollTop()

  tabColor: ->
    @selectedFilter.get('color')

  scrollTo: (position) ->
    @bodyView.$el.scrollTop(position)

  enableSelectAll: ->
    @headerView.hideDisabledSelectAll()
    @headerView.showEnabledSelectAll()

  resetLoadState: ->
    @bodyView.resetLoadCompleted()

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
